/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var GovKoFssIcon16Solid = forwardRef('GovKoFssIcon16Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M9.167.667a.667.667 0 0 0-1.334 0v.735a6.6 6.6 0 0 0 0 13.196v.735a.667.667 0 1 0 1.334 0v-.836a6.602 6.602 0 0 0 0-12.994V.667Zm-1.334 11.58v1.12a5.336 5.336 0 0 1 0-10.665v1.121a4.216 4.216 0 0 0 0 8.423Zm0-2.315v1.124a3.027 3.027 0 0 1 0-6.042v1.124a1.908 1.908 0 0 0 0 3.794Z" })));
});
